<template>
  <AppLayout>
    <el-container class="page-wrap">
      <!-- 左侧：完整版分组菜单 -->
      <el-aside width="195px" class="sidebar">
        <div class="user-info">
          <div class="user-center-badge">用户中心</div>
          <img class="avatar"
                    src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=200&q=80"
                    alt="" />
          <!-- <el-avatar class="avatar" :size="64">U</el-avatar> -->
          <div class="email">{{ profile.email }}</div>
        </div>

        <el-menu class="side-menu" :default-active="activeMenu" :unique-opened="true" @select="onMenuSelect">
          <el-sub-menu index="account">
            <template #title>
              <div class="sub-title">
                <img class="sub-icon" src="../assets/管理账号管理 1@2x.png" alt="" />
                <span class="sub-text">账号管理</span>
                <img class="chevron" src="../assets/cheveron-right@2x.png" alt="" />
              </div>
            </template>

            <el-menu-item index="basic">基本资料</el-menu-item>
            <el-menu-item index="resume">个人简历</el-menu-item>
            <el-menu-item index="tasks">我的发布</el-menu-item>
            <el-menu-item index="auth">实名认证</el-menu-item>
            <el-menu-item index="agreement">用户协议</el-menu-item>
            <el-menu-item index="privacy">隐私政策</el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>

      <!-- 右侧：同页切换 -->
      <el-container class="content">
        <el-main class="main">
          <div class="panel">
            <component :is="activeComponent" :profile="profile" @edit="onEdit" @update-profile="onUpdateProfile" />
          </div>
        </el-main>
      </el-container>
    </el-container>
  </AppLayout>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import AppLayout from '@/layouts/AppLayout.vue'

import BasicSection from './sections/BasicSection.vue'
import ResumeSection from './sections/ResumeSection.vue'
import MyTasksSection from './sections/MyTasksSection.vue'
import AuthSection from './sections/AuthSection.vue'
import AgreementSection from './sections/AgreementSection.vue'
import PrivacySection from './sections/PrivacySection.vue'

const activeMenu = ref('basic')

const profile = reactive({
  nickname: '蓝豆',
  email: '123456@126.com',
  phone: '150****5678',
})

const componentMap = {
  basic: BasicSection,
  resume: ResumeSection,
  tasks: MyTasksSection,
  auth: AuthSection,
  agreement: AgreementSection,
  privacy: PrivacySection,
}

const activeComponent = computed(() => componentMap[activeMenu.value] || BasicSection)

function onMenuSelect(index) {
  activeMenu.value = index
}

function onEdit(field) {
  console.log('edit from child:', field)
}

function onUpdateProfile(patch) {
  Object.assign(profile, patch)
}
</script>

<style scoped>
.page-wrap {
  min-height: calc(100vh - 64px);
  padding: 24px 80px 64px;
  background:
    radial-gradient(1200px 520px at 75% 25%, rgba(76, 175, 80, 0.08), transparent 60%),
    radial-gradient(980px 520px at 22% 70%, rgba(76, 175, 80, 0.06), transparent 60%),
    #f6faf7;
  box-sizing: border-box;
}

@media (max-width: 1400px) {
  .page-wrap {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media (max-width: 960px) {
  .page-wrap {
    padding: 24px 16px 48px;
  }
}

.sidebar {
  padding-top: 0;
  background: transparent;
}

.user-info {
  height: 190px;
  background: rgba(184, 242, 189, 0.35);
  border: 1px solid rgba(76, 175, 80, 0.12);
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.user-center-badge {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 124px;
  height: 30px;
  background: #4caf50;
  border-radius: 0px 0px 12px 12px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  margin-top: 14px;
  width: 58px;
height: 58px;
border-radius: 50%;
}

.email {
  margin-top: 11px;
  font-size: 13px;
  color: #606266;
}

:deep(.side-menu.el-menu) {
  border-right: none;
  background: #fff;
  /* border-left: 1px solid #4caf50;
  border-right: 1px solid #4caf50;
  border-bottom: 1px solid #4caf50; */
  border-top: 0;
  padding: 8px 0 12px;
  height: 681px;
}

/* 隐藏 Element Plus 自带的 sub-menu 箭头（避免与图片重复） */
:deep(.side-menu .el-sub-menu__icon-arrow) {
  display: none !important;
}

.sub-title {
  display: inline-flex;
  align-items: center;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  color: #4caf50;
}

.sub-icon {
  width: 23px;
  height: 23px;
  margin-right: 7px;
}

.sub-text {
  white-space: nowrap;
}

.chevron {
  width: 20px;
  height: 20px;
  margin-left: auto;
}

:deep(.side-menu .el-sub-menu__title) {
  height: 44px;
  line-height: 44px;
  padding-left: 18px !important;
  padding-right: 14px !important;
}

/* 菜单项基础 */
:deep(.side-menu .el-menu-item) {
  height: 44px;
  line-height: 44px;
  font-weight: 400;
font-size: 14px;
color: #333333;
  padding-left: 52px !important;
  background: transparent;
  /* 默认无底色 */
}

/* 吐掉鼠标移入时 Element Plus 自带背景色（hover） */
:deep(.side-menu .el-menu-item:hover) {
  background-color: transparent !important;
}

/* 也把 sub-menu 标题 hover 的底色吐掉（可选但建议一起处理） */
:deep(.side-menu .el-sub-menu__title:hover) {
  background-color: transparent !important;
}

/* 激活态：绿色条 + 浅绿底（保持不变） */
:deep(.side-menu .el-menu-item.is-active) {
  background: #EEFFEF;
  border-radius: 8px 8px 8px 8px;
  border-left: 4px solid #4CAF50;
  position: relative;
  font-weight: 500;
  font-size: 14px;
  color: #4CAF50;
}


.main {
  padding: 0;
  margin-left: 18px;
}

.panel {
  min-height: 872px;
  background: #fff;
  border: 1px solid rgba(76, 175, 80, 0.08);
  box-sizing: border-box;
  padding: 16px;
}
</style>